function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212A33",
  fillRule: "evenodd",
  d: "m13.418 2.587 7.995 7.995a2.006 2.006 0 0 1 0 2.836l-7.995 7.995a2.006 2.006 0 0 1-2.836 0l-7.995-7.995a2.006 2.006 0 0 1 0-2.836l7.995-7.995a2.006 2.006 0 0 1 2.836 0M13.5 8c-.276 0-.5.255-.5.532V10h-2c-1.657 0-3 1.338-3 3v2a.999.999 0 1 0 2 0v-1.478c0-.831.672-1.522 1.5-1.522H13v1.495a.499.499 0 0 0 .848.36l3.581-2.481.012-.011a.503.503 0 0 0-.012-.71l-3.581-2.481C13.755 8.082 13.63 8 13.5 8"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-directions.svg";
export { SvgComponent as ReactComponent };